export interface AdvertViewAdvertLocationDTO {
  countyLat?: number;
  countyLng?: number;
  countyName?: string;
  countyPlaceId?: string;
}
